import React, {Component} from 'react';
import {Grid, Button, FormGroup, FormControl} from 'react-bootstrap';
import './Announcements.css';


export default class Announcements extends Component {

    render() {
        return (
            <Grid>
                Duyurular Gelecek
            </Grid>

        )
    }

}


// WEBPACK FOOTER //
// ./src/components/Announcements.js